module.exports = __webpack_public_path__ + "assets/AirbnbCerealBold.6021dfe8dec0b7e6578d6acb473c0121.woff";